module.exports = __webpack_public_path__ + "static/img/IMG_5463.e41ef49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_5463.jpg
// module id = 286
// module chunks = 0